import $ from 'jquery';

const $window = $(window);
const debounceDelay = 250;
const animationDuration = 300;
const swipeTreshold = { x: 30, y: 30 };
const carrouselEl = $('.carrousel__wrapper');

function init(element, data) {
    let cardWrapper = element.find('.carrousel__card_wrapper');
    let card = element.find('.carrousel__card');
    let windowWidth = $window.width();

    data.itemWidth = card.outerWidth(true);
    data.offsetRight = parseInt(windowWidth - (cardWrapper.offset().left + cardWrapper.outerWidth()));
    scrollToItem(element, data, 0, false);

    if (windowWidth < 2 * data.itemWidth) {
        let itemWidthNoMargin = card.outerWidth();
        let padding = (windowWidth - itemWidthNoMargin) / 2 + 'px';
        cardWrapper.css({
            'padding-left': padding,
            'padding-right': padding,
        });
    } else {
        cardWrapper.removeAttr('style');
    }
}

function isScrolledRight(data) {
    return Math.abs(data.offsetRight) <= 0;
}

function scrollLeft(element, data) {
    if (data.item > 0) {
        data.item--;
        scrollToItem(element, data, animationDuration, false);
    }
}

function scrollRight(element, data) {
    if (!isScrolledRight(data)) {
        data.item++;
        scrollToItem(element, data, animationDuration);
    }
}

function scrollToItem(element, data, duration, endstep = true, speedMultiplier = 1, position = data.item * data.itemWidth) {
    let cardWrapper = element.find('.carrousel__card_wrapper');
    let carrousel = element.find('.carrousel');

    var distance = Math.abs(carrousel.scrollLeft() - position);
    if (distance > data.itemWidth) {
        speedMultiplier = distance / data.itemWidth;
    }

    carrousel.animate({ scrollLeft: position }, duration * speedMultiplier, 'linear', function () {
        data.offsetRight = parseInt($window.width() - (cardWrapper.offset().left + cardWrapper.outerWidth()));
        if (endstep) {
            if (Math.abs(data.offsetRight) <= data.itemWidth / 2 && !isScrolledRight(data)) {
                data.item++;
                scrollToItem(element, data, duration, false, Math.abs(data.offsetRight) / data.itemWidth, position + Math.abs(data.offsetRight));
            }
        }

        if (data.item == 0) {
            element.addClass('carrousel_left');
        } else {
            element.removeClass('carrousel_left');
        }

        if (isScrolledRight(data)) {
            element.addClass('carrousel_right');
        } else {
            element.removeClass('carrousel_right');
        }
    });
}

function onTouchStart(event, data) {
    let evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    let touch = evt.touches[0] || evt.changedTouches[0];
    data.startMousePos.x = touch.pageX;
    data.startMousePos.y = touch.pageY;
}

function onTouchEnd(event, element, data) {
    let evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    let touch = evt.touches[0] || evt.changedTouches[0];
    data.endMousePos.x = touch.pageX;
    data.endMousePos.y = touch.pageY;

    let mousePosDiff = {
        x: data.startMousePos.x - data.endMousePos.x,
        y: data.startMousePos.y - data.endMousePos.y,
    };

    data.startMousePos = { x: -1, y: -1 };
    data.endMousePos = { x: -1, y: -1 };

    if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
        if (mousePosDiff.x > 0) {
            scrollRight(element, data);
        } else {
            scrollLeft(element, data);
        }
    }
}

$(function () {
    carrouselEl.each(function () {
        let element = $(this);
        let prev = element.find('.carrousel__prev');
        let next = element.find('.carrousel__next');
        let data = {
            timeout: false,
            item: 0,
            itemWidth: -1,
            offsetRight: -1,
            startMousePos: { x: -1, y: -1 },
            endMousePos: { x: -1, y: -1 },
        };

        init(element, data);
        $window.on('resize', function () {
            clearTimeout(data.timeout);
            data.timeout = setTimeout(function () {
                init(element, data);
            }, debounceDelay);
        });

        prev.on('click', function () {
            scrollLeft(element, data);
        });
        next.on('click', function () {
            scrollRight(element, data);
        });

        element.on('touchstart', function (event) {
            onTouchStart(event, data);
        });
        element.on('touchend', function (event) {
            onTouchEnd(event, element, data);
        });
    });
});
